import { AccordionTypes, UI, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import React, { useState } from 'react';

export const FixedIncomeRules: React.FC = () => {
  const [accordionState, setAccordionState] = useState<AccordionTypes.Status>('closed');

  const handlePress = () => {
    setAccordionState((prevState) => (prevState === 'closed' ? 'opened' : 'closed'));
  };

  const handleClose = () => {
    setAccordionState('closed');
  };

  return (
    <Stack bgColor={Color.background} borderRadius={BoxBorder.heavy}>
      <UI.Accordion
        testId="customer-info-panel"
        status={accordionState}
        onPress={handlePress}
        hasShadow={false}
        onClosed={handleClose}>
        <UI.Accordion.Visible>
          <UI.Text variant="semibold">REGRAS DE RESGATE</UI.Text>
        </UI.Accordion.Visible>
        <UI.Accordion.Expanded>
          <VStack space={Spacing['stack.xxxs']}>
            <UI.Text>A cotação é válida por 1 dia útil. Após esse prazo, ela é cancelada.</UI.Text>
            <UI.Text>
              Você terá até as 20h30 do mesmo dia para aprovar ou rejeitar o valor da cotação.
            </UI.Text>
            <UI.Text>Caso aprovada, você receberá um e-mail com a confirmação do resgate.</UI.Text>
            <UI.Text>O valor será liquidado em 1 dia útil após a aprovação.</UI.Text>
          </VStack>
        </UI.Accordion.Expanded>
      </UI.Accordion>
    </Stack>
  );
};
